export const ENV_CONFIG_ATTRIBUTES = {
  ENV: 'ENV',
  AUTH_CLIENT_ID: 'AUTH_CLIENT_ID',
  AUTH_SCOPES: 'AUTH_SCOPES',
  AUTH_URL: 'AUTH_URL',
  AUTH_TOKEN_URL: 'AUTH_TOKEN_URL',
  AUTH_THEME: 'AUTH_THEME',
  ALTIBOX_MY_PAGES_URL: 'ALTIBOX_MY_PAGES_URL',
  CUSTOMER_SERVICE_URL: 'CUSTOMER_SERVICE_URL',
  TERMS_LINK_URL: 'TERMS_LINK_URL',
  GET_STARTED_URL: 'GET_STARTED_URL',
  CUSTOMER_SERVICE_XBOX_URL: 'CUSTOMER_SERVICE_XBOX_URL',
  MAIN_PAGE_URL: 'MAIN_PAGE_URL',
  GAME_PASS_PAGE_URL: 'GAME_PASS_PAGE_URL',
  LANGUAGE: 'LANGUAGE',
};
